import {useQuery} from 'react-query'
import {ProvinceEditModalForm} from './ProvinceEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getProvinceById} from '../core/_requests'

const ProvinceEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: province,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-province-${itemIdForUpdate}`,
    () => {
      return getProvinceById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <ProvinceEditModalForm isProvinceLoading={isLoading} province={{id: undefined}} />
  }

  if (!isLoading && !error && province) {
    console.log({province, },"its province")
    console.log(typeof province,"its province")
    return <ProvinceEditModalForm isProvinceLoading={isLoading} province={province} />
  }

  return null
}

export {ProvinceEditModalFormWrapper}
